import { MOBILE_BREAKPOINT } from "../const/config";

export function importAll(r) {
  return r.keys().map(r);
}

export function detectDevice() {
  const ua = navigator.userAgent;
  if (/android/i.test(ua)) return "android";
  if (/iPhone|iPad|iPod/i.test(ua)) return "ios";

  // Desktop browser nhưng đang ở chế độ responsive nhỏ
  if (window.innerWidth < MOBILE_BREAKPOINT) return "android";

  return "desktop";
}
